/** Tenant bill statistics /metering/bill/floating-price-tenant (floatingPrice.vue) */
export default {
  floatingPriceTenantPage: {
    phDateStart: 'Start date',
    phDateEnd: 'End date',
    phTenant: 'Tenant name / ID',
    phTenantType: 'Tenant type',
    phPayType: 'Payment mode',
    phArrearsType: 'Arrears type',
    tenantType0: 'Tenant',
    tenantType1: 'Common area',
    tenantType2: 'Other',
    tenantType3: 'Solar',
    optPayPrepaid: 'Prepaid',
    optPayPostpaid: 'Postpaid',
    arrearsType1: 'Electricity arrears',
    arrearsType2: 'Water arrears',
    arrearsType3: 'Service fee arrears',
    arrearsType4: 'Has arrears',
    arrearsType5: 'All settled',
    btnSearch: 'Search',
    btnReset: 'Reset',
    btnExport: 'Export',
    btnExpand: 'Expand',
    btnCollapse: 'Collapse',
    exportCurrentPage: 'Export current page',
    exportSelected: 'Export selected',
    exportAll: 'Export all',
    kpiBillTotal: 'Receivable (¥)',
    kpiPayTotal: 'Received (¥)',
    kpiPrepaidRate: 'Prepaid collection rate',
    sectionTitle: 'Bill statistics',
    sortDefault: 'Default sort',
    selectedLine: '<span class="count">{count}</span> row(s) selected',
    colTenantId: 'Tenant ID',
    colResourceList: 'Resources',
    colTenantName: 'Tenant',
    colPayType: 'Payment mode',
    colElecAmt: 'Electricity bills',
    colElecPayAmt: 'Electricity (paid)',
    colElecNoPayAmt: 'Electricity (unpaid)',
    colWaterAmt: 'Water bills',
    colWaterPayAmt: 'Water (paid)',
    colWaterNoPayAmt: 'Water (unpaid)',
    colServiceAmt: 'Service fee bills',
    colServicePayAmt: 'Service fee (paid)',
    colServiceNoPayAmt: 'Service fee (unpaid)',
    msgTenantListFail: 'Failed to load tenant list',
    msgFetchFail: 'Failed to load data',
    msgFetchStatFail: 'Failed to load bill statistics',
    msgNoDataExport: 'No data to export',
    msgExportOk: 'Export completed.',
    msgExportOkSelected: 'Exported {count} selected row(s).',
    warnNoSelectedExport: 'Please select rows to export',
    successExported: 'Exported {count} row(s)',
    successExportedLimit: '{total} row(s) in total, first {count} row(s) exported',
    exporting: 'Exporting...',
    msgExportFail: 'Export failed. Please try again.',
    exportSheetName: 'Tenant bill statistics',
    filePrefix: 'TenantBillStatistics',
    resourceMore: '{name} and {count} more resources'
  }
}
